/**
 * Utility function to capitalize a single word. Returns the given string with the first
 * character capitalized if it isn't already.
 */
export default (str: string) => [str[0]?.toUpperCase(), str.slice(1)].filter(Boolean).join('')
